import HeaderVerde from '../HeaderVerde'
import Input from '../Input'
import Select from '../Select'
import Observacoes from '../Observacoes'
import Caixa from '../Caixa'
import CheckContainer from '../CheckContainer'
import CheckBox from '../CheckBox'
import React from 'react'

import { useSelector } from 'react-redux'

const LegalidadeCofito517 = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const ficha = useSelector((state) => state.addForm.ficha)

    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if(ficha[modulo]) var qtdFicha = ficha[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <Caixa>
                    <HeaderVerde texto="LEGALIDADE" />
                    <div style={{ textAlign: "left" }}>
                        <Select label="CONFORMIDADE COM A RESOLUÇÃO COFFITO Nº 517/2020" nome="resolucao517" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="8vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                             <Select label="UTILIZAÇÃO DE EPI POR PARTE DO PROFISSIONAL EM CONFORMIDADE COM A NOTA TÉCNICA ANVISA 04/2020 e nota técnica ANVISA 07/2020" nome="resolucao517" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="8vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                    </div>

                    <Observacoes widthWeb="83vw" widthMobile="80vw" />
                </Caixa>
            )
        }
        return partes
    }
}

export default LegalidadeCofito517